import DateFilterPill from './DateFilterPill';
import MultiSelectFilterPill from './MultiSelectFilterPill';

const BillingFilterPill = {
    DATE: DateFilterPill,
    MULTISELECT: MultiSelectFilterPill,
};

export default BillingFilterPill;
